import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuth } from "@mbj-front-monorepo/data-access";

interface PublicRouteCtrlProps {}

export function PublicRouteCtrl(props: PublicRouteCtrlProps) {
  return <Outlet />;
}
